module.exports = __webpack_public_path__ + "img/ru-uid.a3b7d97.png";